(()=>{
  const dialog=document.getElementById('acl-winter-signup');
  if(!dialog||dialog.dataset.initialized)return;
  dialog.dataset.initialized='true';
  const config=JSON.parse(document.getElementById('acl-winter-config').textContent);
  const form=dialog.querySelector('form');
  const email=form.querySelector('[type=email]');
  const consent=form.querySelector('[type=checkbox]');
  const submit=form.querySelector('[type=submit]');
  const error=dialog.querySelector('[data-error]');
  const region=document.getElementById('aclCountryModal');
  const preview=config.preview===true;
  if(preview){
    const hidePrevious=()=>{
      document.querySelectorAll('[role="dialog"][aria-label="Join the Another Cotton Lab newsletter and get 10% off"]').forEach(old=>{
        const closeButton=old.querySelector('button[aria-label="Close dialog"],button[aria-label="Close"]');
        if(closeButton)closeButton.click();
      });
    };
    new MutationObserver(hidePrevious).observe(document.body,{childList:true,subtree:true});
    hidePrevious();
  }
  const key='acl_winter_2026';
  let timer,opened=false,previousFocus,scrollBefore='',wasBlocked=false;
  const read=()=>{try{return JSON.parse(localStorage.getItem(key)||'{}')}catch{return {}}};
  const save=value=>{try{localStorage.setItem(key,JSON.stringify(value))}catch{}};
  const regionBlocked=()=>window.aclRegionGate?.state==='checking'||window.aclRegionGate?.state==='navigating'||(region&&(region.classList.contains('is-open')||region.getAttribute('aria-hidden')==='false'));
  const suppress=()=>{const x=read();return !preview&&(x.submitted||Date.now()-Number(x.closed||0)<3*86400000||config.subscribed)};
  const close=(persist=true)=>{if(!dialog.open)return;dialog.close();document.body.style.overflow=scrollBefore;if(persist&&!preview)save({...read(),closed:Date.now()});previousFocus?.focus?.({preventScroll:true})};
  function show(){if(opened||suppress()||regionBlocked()||document.hidden)return;opened=true;previousFocus=document.activeElement;scrollBefore=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';dialog.querySelector('[data-close]').focus({preventScroll:true});}
  function schedule(){clearTimeout(timer);if(opened||suppress())return;if(regionBlocked()){wasBlocked=true;return;}wasBlocked=false;timer=setTimeout(show,6000)}
  function checkRegion(){if(regionBlocked()){clearTimeout(timer);wasBlocked=true;if(dialog.open){close(false);opened=false}}else if(wasBlocked){schedule()}}
  window.addEventListener('acl:region-state',checkRegion);
  if(region)new MutationObserver(checkRegion).observe(region,{attributes:true,attributeFilter:['class','aria-hidden']});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)clearTimeout(timer);else schedule()});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
  dialog.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',()=>close()));
  dialog.addEventListener('cancel',event=>{event.preventDefault();close()});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close()}});
  const sync=()=>{email.setCustomValidity('');consent.setCustomValidity('');submit.disabled=!email.validity.valid||!email.value||!consent.checked};
  email.addEventListener('input',sync);consent.addEventListener('change',sync);
  email.addEventListener('invalid',()=>email.setCustomValidity(config.invalid));
  consent.addEventListener('invalid',()=>consent.setCustomValidity(config.consent_required));
  const completed=new Set();
  let submitting=false,lastEmail='';
  async function subscribe(listId,address){
    const response=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SLDiNG',{
      method:'POST',headers:{'Content-Type':'application/vnd.api+json','Accept':'application/vnd.api+json','revision':'2026-10-15'},signal:AbortSignal.timeout(15000),
      body:JSON.stringify({
        data:{
          type:'subscription',
          attributes:{
            custom_source:'ACL Winter Collection 2026 signup',
            profile:{data:{type:'profile',attributes:{
              email:address,locale:config.locale,
              properties:{locale:config.locale,'Signup Campaign':'Q4-2026','Signup Device':matchMedia('(max-width:749px)').matches?'Mobile':'Desktop','Winter Collection Launch':'2026-11-12'},
              subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}
            }}}
          },
          relationships:{list:{data:{type:'list',id:listId}}}
        }
      })
    });
    if(response.status!==202)throw new Error('Subscription request failed');
  }
  form.addEventListener('submit',async event=>{
    event.preventDefault();if(submitting||!form.reportValidity())return;
    const address=email.value.trim();if(lastEmail!==address){completed.clear();lastEmail=address}
    submitting=true;submit.disabled=true;submit.textContent=config.sending;error.hidden=true;
    try{
      if(!preview){for(const listId of ['UGrc6G','VPsmSG']){if(!completed.has(listId)){await subscribe(listId,address);completed.add(listId)}}save({submitted:true,closed:Date.now()})}
      form.hidden=true;const success=dialog.querySelector('[data-success]');success.hidden=false;
      success.querySelector('p').textContent=preview?config.preview_success:config.success_body;
      success.querySelector('h3').focus({preventScroll:true});
    }catch{error.textContent=config.error;error.hidden=false}
    finally{submitting=false;submit.textContent=config.submit;sync()}
  });
})();
